import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { ToastService } from 'src/app/services/toast.service';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { clearErrors } from 'src/app/utils/clearFormErrors';
import { toggleBlanket } from 'src/app/utils/toggleBlanket';
import { BudgetService } from '../service/budget.service';

@Component({
  selector: 'njo-budget-product',
  templateUrl: './budget-product.component.html',
  styleUrls: [
    './budget-product.component.scss',
    '../../../../ui/apc-action-card/buttons/action-buttons.component.scss',
  ],
})
export class BudgetProductComponent implements OnInit {
  @Input() product:any = null;
  @Input() budgetId;
  @Input() orderId;
  @Input() isEdit;
  @Input() budgetForm;
  @Output() updateData = new EventEmitter<boolean>(false);
  @Output() clearProducts = new EventEmitter<any>();

  public products: AsyncDropdown[] = [];
  public productsLoading: boolean = false;
  public form: UntypedFormGroup;
  public editForm: boolean = false;
  public hideRow: boolean = false;

  constructor(
    private budgetSerivce: BudgetService,
    private toastService: ToastService,
    public router: Router
  ) {}

  ngOnInit(): void {
    if(this.product != null){
      this.initForm(this.product);
    }
  }

  initForm(data) {
    this.form = new UntypedFormGroup({
      identifier: new UntypedFormControl(data?.identifier),
      product: new UntypedFormControl(data.product, [Validators.required]),
      quantityOrder: new UntypedFormControl(data.quantityOrder, [Validators.required, Validators.min(0)]),
      quantityEstimated: new UntypedFormControl(data.quantityEstimated),
      code: new UntypedFormControl(data.product?.code, [Validators.required]),
    });
  }

  async fetchProducts() {
    this.products = [];
    this.productsLoading = true;
    this.products = await this.budgetSerivce.getBudgetProducts(this.orderId);
    this.productsLoading = false;
  }

  async saveForm() {
    try {
      if (this.form.valid) {
        if (this.form.value?.identifier) {
         let newItem = await this.budgetSerivce.updateBudgetProduct(this.form.value);
         this.budgetForm.patchValue(newItem)
        } else {
          let newItem = await this.budgetSerivce.createBudgetProduct(this.budgetId, this.form.value);
          this.budgetForm.patchValue(newItem)
        }
        this.budgetForm.updateValueAndValidity();
        this.editForm = false;
        this.toastService.showSuccess('Operation success!');
        this.form.markAsPristine();
        this.editFormEvent(false);
        this.updateData.emit(this.budgetId);
      } else {
        this.toastService.showError('Operation error!');
        this.form.markAsPristine();
        this.form.markAllAsTouched();
      }
    } catch (e) {
      clearErrors(this.form);
      this.toastService.showError('Operation error!');
      if (e.validationErrors.length > 0) {
        this.form.markAsPristine();
        checkForValidationErrors(e, this.form);
      }
    }
  }

  editFormEvent(event) {
    this.editForm = event;
    var elId = this.product.identifier ? this.product.identifier : 'new-budget-product';
    toggleBlanket(elId);
    document.getElementById(elId).style.background = this.editForm ? "white" : "unset";
    document.getElementById(elId).style.padding = this.editForm ? "10px" : "unset";
    document.getElementById(elId).style.margin = this.editForm ? "-10px" : "unset";

  }

  async cancelForm() {
    this.form.patchValue(this.product);
    this.form.markAsPristine();
    this.editFormEvent(false);

    if(!this.product.identifier) {
      var hasProducts = false;
      this.budgetForm.controls.budgetProducts.value.forEach(element => {
        if(element.identifier) {
           hasProducts = true;
        }
      });
      //no product delete form card
      if(!hasProducts) {
        this.clearProducts.emit(this.budgetId);
      } else {
        this.hideRow = true;
        document.getElementById("new-budget-product").id = "new-budget-product-deleted";
      }

    }
  }

  async delete() {
    try {
      if (this.product.identifier) {
        let budgetFormResponse = await this.budgetSerivce.deleteBudgetProduct(this.product.identifier);
        this.budgetForm.patchValue(budgetFormResponse);
        this.budgetForm.updateValueAndValidity();
        this.toastService.showSuccess('Operation success!');
        this.hideRow = true;
        this.updateData.emit(this.budgetId);
      } else {
        this.hideRow = true;
      }
    } catch (e) {}
  }

  patchCode(product, form) {
    form.controls.code.patchValue(product.code);
  }

  
}
